module.exports = __webpack_public_path__ + "static/img/1366-bg.8aa6012c.png";